import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const Footer = () => {
    return (
        <footer
            id="download"
            className="bg-gray-50 dark:bg-slate-950 border-t border-slate-200 dark:border-white/10 py-12 transition-colors duration-300"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                <motion.h3
                    initial={{ opacity: 0, y: 15 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5 }}
                    className="text-3xl md:text-4xl font-bold mb-4 text-slate-900 dark:text-white"
                >
                    Ready to Experience
                    <span className="block bg-gradient-to-r from-axionchat-primary to-axionchat-accent bg-clip-text text-transparent">
                        Next-Gen Messaging?
                    </span>
                </motion.h3>
                <motion.p
                    initial={{ opacity: 0, y: 15 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: 0.05 }}
                    className="mb-8 text-slate-600 dark:text-slate-400 text-lg"
                >
                    Download AxionChat now. Available exclusively on Google Play Store.
                </motion.p>

                <motion.a
                    href="https://play.google.com/store/apps/details?id=com.sachin.axionchat"
                    target="_blank"
                    rel="noreferrer"
                    className="inline-flex items-center justify-center px-10 py-4 text-lg font-bold text-white bg-gradient-to-r from-axionchat-primary to-axionchat-secondary rounded-2xl shadow-2xl shadow-axionchat-primary/50 hover:shadow-axionchat-primary/70 transition-all duration-300 mb-10"
                    whileHover={{ scale: 1.06, y: -2 }}
                    whileTap={{ scale: 0.96 }}
                >
                    <img
                        src="/assets/playstore.png"
                        alt="Google Play"
                        className="w-8 h-8 mr-3"
                    />
                    Get AxionChat
                </motion.a>

                <motion.div
                    initial={{ opacity: 0, y: 15 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: 0.1 }}
                    className="mb-6"
                >
                    <Link
                        to="/downloads/old-versions"
                        className="text-sm text-axionchat-accent hover:text-axionchat-primary transition duration-200 underline underline-offset-4 font-medium"
                    >
                        Download older versions (APK)
                    </Link>
                </motion.div>

                {/* Social Media Links */}
                <div className="flex justify-center gap-6 mb-8">
                    <a
                        href="https://x.com/axionchat"
                        target="_blank"
                        rel="noreferrer"
                        className="text-slate-400 hover:text-slate-900 dark:hover:text-white transition-colors duration-300"
                        aria-label="Follow us on X (Twitter)"
                    >
                        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                            <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                        </svg>
                    </a>
                    <a
                        href="https://www.linkedin.com/company/axionchat"
                        target="_blank"
                        rel="noreferrer"
                        className="text-slate-400 hover:text-[#0A66C2] transition-colors duration-300"
                        aria-label="Connect with us on LinkedIn"
                    >
                        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                            <path fillRule="evenodd" d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" clipRule="evenodd" />
                        </svg>
                    </a>
                    <a
                        href="https://www.instagram.com/axionchat"
                        target="_blank"
                        rel="noreferrer"
                        className="text-slate-400 hover:text-[#E4405F] transition-colors duration-300"
                        aria-label="Follow us on Instagram"
                    >
                        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                            <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.416 2.045c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd" />
                        </svg>
                    </a>
                </div>

                <div className="space-x-4 text-sm text-slate-500 dark:text-slate-400 mb-6">
                    <a
                        href="https://sites.google.com/view/axionchat-terms"
                        target="_blank"
                        rel="noreferrer"
                        className="hover:text-slate-900 dark:hover:text-slate-100 transition duration-200 font-medium"
                    >
                        Terms of Service
                    </a>
                    <span>•</span>
                    <a
                        href="https://sites.google.com/view/axionchat-privacy"
                        target="_blank"
                        rel="noreferrer"
                        className="hover:text-slate-900 dark:hover:text-slate-100 transition duration-200 font-medium"
                    >
                        Privacy Policy
                    </a>
                    <span>•</span>
                    <a
                        href="#contact"
                        className="hover:text-slate-900 dark:hover:text-slate-100 transition duration-200 font-medium"
                    >
                        Support
                    </a>
                </div>

                <p className="text-xs text-slate-500">
                    &copy; {new Date().getFullYear()} AxionChat. All rights reserved. Built with ❤️ using Flutter.
                </p>
            </div>
        </footer>
    );
};

export default Footer;
